import React from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'

const StyledText = styled.span`
  font-size: 1rem;
  font-weight: ${STYLES.FONT_WEIGHT_NORMAL};
`

interface ITextProps {
  children: React.ReactNode
  className?: string
  style?: object
}

const Text: React.FC<ITextProps> = ({ children, className, style }) => (
  <StyledText className={className} style={style}>
    {children}
  </StyledText>
)

export { Text }
